import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '@core/services/s_auth';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

/**
 * Interceptor para manejar errores globales de HTTP
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(Auth);
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 1. Manejo de errores de autenticación (Token expirado o inválido)
      if (error.status === 401 || error.status === 403) {
        auth.signOut().then(() => {
          router.navigate(['/login']);
        });
      }

      // 2. Manejo de errores de servidor (500)
      else if (error.status === 500) {
        messageService.add({
          severity: 'error',
          summary: 'Error de Servidor (500)',
          detail: 'Ocurrió un problema interno en el servidor. Por favor, intenta más tarde.',
          life: 5000,
        });
      }

      // 3. Otros errores (404, 400, etc.)
      else {
        messageService.add({
          severity: 'warn',
          summary: `Error (${error.status})`,
          detail: error.message || 'Ocurrió un error inesperado en la petición.',
          life: 4000,
        });
      }

      return throwError(() => error);
    })
  );
};
